module.exports = __webpack_public_path__ + "static/media/gryphon_version_infinity_logo.834e66ca.svg";